/**
 * @file Config helper.
 */
import { loadStripe } from '@stripe/stripe-js';

const getConfig = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  // eslint-disable-next-line no-underscore-dangle
  return window.__ENV_VARS__;
};

const getGqlBaseUrl = () => {
  const config = getConfig();

  return (config?.graphql.clientUrl ?? '').replace('/gql', '/');
};

export default getConfig;

const isDev = () => {
  const config = getConfig();

  return ['local', 'dev'].includes(config?.app?.env);
};

const StripeInstance = getConfig()?.stripe.key
  ? loadStripe(getConfig().stripe.key)
  : null;

const getStripeInstance = stripeConnectAccountId => {
  if (!getConfig()?.stripe.key) {
    return null;
  }

  return loadStripe(getConfig().stripe.key, {
    stripeAccount: stripeConnectAccountId,
  });
};

export { getGqlBaseUrl, isDev, StripeInstance, getStripeInstance };
